<script setup lang="ts">
const props = defineProps<{
    description: string
    class?: string
}>()
</script>

<template>
    <div
        v-html-gpp="description"
        :class="[props.class]"
    />
</template>
